import SettingLink from './SettingLink.vue';

export default SettingLink;
